/**
 * The dip-chip step: a Thai national ID card inserted into a contact card
 * reader (`sdk/contract/dip-chip.md`). The screen is `./DipChipStep`.
 *
 * A browser cannot read the card — WebUSB blocks the smart-card class — so the
 * card is read on a partner terminal: the kiosk, a desktop app on the desktop
 * SDK, or an Android/iOS device with a USB reader. `CHIP_READ` is fired by the
 * SERVER once it has opened the terminal's sealed read
 * (`POST /flow/{id}/collection/chip`); the events route refuses it from a
 * client. The SPA lists it only so the step renders.
 */
export const CHIP_READ_EVENT = 'CHIP_READ';
